module.exports = __webpack_public_path__ + "img/87.66621189.jpg";